export default {
  search: {
    title: "Cerca",
    trending: "In tendenza",
    noResults: 'Nessun risultato trovato per "{{query}}"',
    sections: {
      games: "Partite",
      props: "Props",
      position: "Posizione",
      trending: "In tendenza",
      players: "Giocatori",
      teams: "Squadre",
      markets: "Mercati",
      matchups: "Matchup",
    },
    empty: {
      noResults: 'Nessun risultato trovato per "{{query}}"',
      noGamesAvailable: "Nessuna partita disponibile",
      checkBackLater: "Riprova più tardi",
    },
    actions: {
      searchByGame: "Cerca per partita",
      viewMatchups: "Vedi matchup",
      searchByProp: "Cerca per prop",
      searchByPosition: "Cerca per posizione",
    },
    discovery: {
      Hits: "Hit",
      "Total Bases": "Basi totali",
      RBI: "RBI",
      Strikeouts: "Strikeout",
      Results: "Risultati",
      Totals: "Totali",
      "Goals & Assists": "Gol e assist",
      "Shots on Goal": "Tiri in porta",
      Points: "Punti",
      "Powerplay Points": "Powerplay Points",
    },
    positions: {
      Forwards: "Attaccanti",
      Midfielders: "Centrocampisti",
      Defense: "Difesa",
      Guards: "Guards",
      Centers: "Centers",
      QB: "QB",
      RB: "RB",
      WR: "WR",
      TE: "TE",
      K: "K",
      Wingers: "Ali",
      Goalies: "Portieri",
      Pitchers: "Lanciatori",
      Hitters: "Battitori",
    },
  },
};